// extracted by mini-css-extract-plugin
export default {"pageWrap":"ib-z","fullWidth":"jb-z","heading":"kb-z","fullBleed":"lb-z","hidden":"mb-z"};